module.exports = __webpack_public_path__ + "img/xiaohongshu.b34bcf29.png";